import React, { useState } from 'react';
import { Alert, AlertTitle, Box } from '@mui/material';

/**
 * Разбор description на записи о корректировках.
 *
 * Бэкенд дописывает строки вида «[КОРРЕКТИРОВКА 2026-08-19] причина» в
 * description заказа/отгрузки (order.js changeStatus, webhook track-check,
 * oil-filling-controller). Записей может быть несколько - собираем все.
 *
 * @param {string} description
 * @returns {Array<{date: string, reason: string}>}
 */
export function parseCorrections(description) {
    if (!description || typeof description !== 'string') return [];
    const re = /\[КОРРЕКТИРОВКА (\d{4}-\d{2}-\d{2})\]\s*([^\n]*)/g;
    const out = [];
    let m;
    while ((m = re.exec(description)) !== null) {
        out.push({ date: m[1], reason: (m[2] || '').trim() || 'причина не указана' });
    }
    return out;
}

/**
 * Баннер «заказ был на корректировке» для OrderById/DemandById.
 *
 * Показывается, если в description есть записи [КОРРЕКТИРОВКА ...], с датой и
 * причиной каждой. Закрытие действует на текущий просмотр: при следующем
 * открытии заказа баннер вернётся - для сборщика/упаковщика это рабочая
 * информация, прятать её навсегда нельзя.
 */
export default function CorrectionNotice({ description }) {
    const corrections = parseCorrections(description);
    const [dismissed, setDismissed] = useState(false);

    if (dismissed || corrections.length === 0) return null;

    return (
        <Alert
            severity="warning"
            sx={{ m: 2 }}
            onClose={() => setDismissed(true)}
        >
            <AlertTitle>
                {corrections.length === 1
                    ? `Заказ был на корректировке ${corrections[0].date}`
                    : `Заказ был на корректировке ${corrections.length} раз(а)`}
            </AlertTitle>
            {corrections.map((c, i) => (
                <Box key={i} component="div">
                    {corrections.length > 1 && <strong>{c.date}: </strong>}
                    {c.reason}
                </Box>
            ))}
        </Alert>
    );
}
